import store from '@/store'
import authenticationStore from '@/store/modules/authentication.store'
import { LOGIN_ROUTE, HOME_ROUTE, extractRedirect, routerState } from '../utils'

function handleAuthenticated(to, from, next) {
  if (to.name === null) {
    if (from.name === null) {
      next(HOME_ROUTE)
      return routerState.REDIRECTED
    }

    next(false)
    return routerState.CANCELED
  }

  return routerState.ALLOWED
}

function handleUnauthenticated(to, from, next) {
  const unauthenticatedRedirect = extractRedirect(to, 'unauthenticated')
  if (unauthenticatedRedirect) {
    next(unauthenticatedRedirect)
    return routerState.REDIRECTED
  }

  if (to.name === null) {
    if (from.name === null) {
      next(LOGIN_ROUTE)
      return routerState.REDIRECTED
    }

    next(false)
    return routerState.CANCELED
  }

  return routerState.ALLOWED
}

function checkAuthentication(to, from, next) {
  const isAuthenticated = authenticationStore.state.authenticated
  if (isAuthenticated) {
    return handleAuthenticated(to, from, next)
  }

  return handleUnauthenticated(to, from, next)
}

export default async (to, from, next) => {
  if (!authenticationStore.state.loaded) {
    return new Promise(resolve => {
      store.watch(
        state => state.authentication.loaded,
        loaded => {
          if (loaded) {
            resolve(checkAuthentication(to, from, next))
          }
        }
      )
    })
  } else {
    return checkAuthentication(to, from, next)
  }
}
